export { default as CurrencyDollarSolidIcon } from './CurrencyDollarSolidIcon';
